export const AG = {
  AG: 'AG',
  CLEAR: 'CLEAR',
}
